// extracted by mini-css-extract-plugin
module.exports = {"action-bar":"_3R1GzexYa18vB2Bxb6Rzlb","actionBar":"_3R1GzexYa18vB2Bxb6Rzlb","dashboard":"_1VECCzabeZZQQfNdvLyngE"};